(function(){
'use strict';



function resetLanguageModalScroll(){
  var body=document.querySelector('#pmy-language-region-modal .pmy-lang-body');
  if(body) body.scrollTop=0;
}
function bindLanguageModal(){
  document.addEventListener('click',function(e){
    if(e.target.closest('.pmy-lang-globe') || e.target.closest('.pmy-footer-lang')) requestAnimationFrame(resetLanguageModalScroll);
  },true);
}
function placeFooterUtilityButtons(){
  var footer=document.querySelector('.main-footer');
  if(!footer) return false;
  var shell=footer.querySelector('.footer-shell');
  var reviews=footer.querySelector('.footer-reviews');
  var row=footer.querySelector('.pmy-a11y-footer-row');
  var lang=footer.querySelector('.pmy-footer-lang');
  var payments=footer.querySelector('.footer-payments-band');
  var bottom=footer.querySelector('.footer-bottom');
  if(bottom) bottom.classList.remove('pmy-footer-language');
  if(!shell || !reviews || !row || !lang) return false;
  var trio=footer.querySelector('.pmy-footer-utility-trio');
  if(!trio){
    trio=document.createElement('div');
    trio.className='pmy-footer-utility-trio';
    if(payments && payments.parentNode===shell) shell.insertBefore(trio,payments); else shell.appendChild(trio);
  }
  if(reviews.parentNode!==trio) trio.appendChild(reviews);
  if(row.parentNode!==trio) trio.appendChild(row);
  if(lang.parentNode!==row) row.appendChild(lang);
  row.classList.add('pmy-footer-utility-actions');
  return true;
}
function setupFooterUtilityButtons(){
  var footer=document.querySelector('.main-footer');
  if(!footer) return;
  if(placeFooterUtilityButtons()) return;
  var observer=new MutationObserver(function(){if(placeFooterUtilityButtons()) observer.disconnect();});
  observer.observe(footer,{childList:true,subtree:true});
  [0,60,180,500,1200].forEach(function(delay){setTimeout(placeFooterUtilityButtons,delay);});
}
function setupFabCollision(){
  var fab=document.querySelector('.mobile-fab-checkout');
  var footerBottom=document.querySelector('.main-footer .footer-bottom');
  if(!fab || !footerBottom) return;
  var ticking=false;
  function update(){
    ticking=false;
    if(window.innerWidth>1199){fab.style.removeProperty('--pmy-fab-lift');return;}
    var r=footerBottom.getBoundingClientRect();
    var base=20;
    var lift=base;
    if(r.top < window.innerHeight && r.bottom > 0) lift=Math.max(base,Math.round(window.innerHeight-r.top+14));
    fab.style.setProperty('--pmy-fab-lift',lift+'px');
  }
  function schedule(){if(ticking)return;ticking=true;requestAnimationFrame(update);}
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('scroll',schedule,true);
  if('ResizeObserver' in window) new ResizeObserver(schedule).observe(footerBottom);
  update();
}
function syncTripadvisorReviewCount(){
  var nodes=Array.prototype.slice.call(document.querySelectorAll('.main-footer .tripadvisor-card .ta-copy small'));
  if(!nodes.length) return;
  var locale=document.documentElement.lang || 'en';
  function formatCount(value){var number=Number(value);if(!Number.isFinite(number)||number<=0)return '';try{return new Intl.NumberFormat(locale).format(number)}catch(e){return String(number)}}
  function getLabel(node){if(node.dataset.pmyReviewLabel)return node.dataset.pmyReviewLabel;var label=(node.textContent||'').replace(/^[\s\d.,\u00a0]+/,'').trim()||'reviews';node.dataset.pmyReviewLabel=label;return label;}
  function paint(value){var formatted=formatCount(value);if(!formatted)return;nodes.forEach(function(node){node.textContent=formatted+' '+getLabel(node);});}
  nodes.forEach(function(node){getLabel(node);});
  paint(1106);
  var feed='https://pmy-tripadvisor-reviews.vercel.app/api/reviews';
  if(!window.PMYTripadvisorFeedPromise){
    window.PMYTripadvisorFeedPromise=fetch(feed,{method:'GET',headers:{Accept:'application/json'}}).then(function(response){if(!response.ok)throw new Error('Tripadvisor reviews feed returned '+response.status);return response.json();});
  }
  window.PMYTripadvisorFeedPromise.then(function(payload){
    var data=payload && payload.data && !Array.isArray(payload.data) ? payload.data : payload;
    if(!data)return;
    var count=data.review_count;
    if(count===undefined||count===null)count=data.reviewCount;
    if(count===undefined||count===null)count=data.total_count;
    if(count===undefined||count===null)count=data.total;
    if(count===undefined||count===null)count=data.count;
    if((count===undefined||count===null)&&data.traveler_ratings&&data.traveler_ratings.overall)count=data.traveler_ratings.overall.count;
    paint(count);
  }).catch(function(){});
}
function init(){bindLanguageModal();setupFooterUtilityButtons();setupFabCollision();syncTripadvisorReviewCount();}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
document.addEventListener('shopify:section:load',function(){setupFooterUtilityButtons();syncTripadvisorReviewCount();});
})();
